import { HardBlockCardRequest } from '@/react-query/services/block';

import { BlockReason, Card, CardReorder, HardBlockReason } from '@generated-types';

const getDebitCardReorderRequest = (reorder: boolean, pinChanged: boolean): CardReorder | undefined => {
    if (!reorder) {
        return undefined;
    }

    return {
        automatic: true,
        changePin: pinChanged,
    };
};

type ExcludeValue<T, V> = T extends V ? never : T;

interface HardBlockInfo {
    card: Card;
    reason: ExcludeValue<HardBlockReason, 'NOT_IN_USE'>;
    reorder: boolean;
    pinChanged: boolean;
}

const asDebitReason = (reason: ExcludeValue<HardBlockReason, 'NOT_IN_USE'>) => {
    if (reason === HardBlockReason.DAMAGED) {
        return BlockReason.DAMAGED;
    }

    if (reason === HardBlockReason.LOST) {
        return BlockReason.LOST;
    }

    return BlockReason.STOLEN;
};

export const getHardBlockRequest = ({ card, reason, reorder, pinChanged }: HardBlockInfo): HardBlockCardRequest => {
    return {
        cardId: card.id,
        blockRequest: { reason: asDebitReason(reason), reorder: getDebitCardReorderRequest(reorder, pinChanged) },
    };
};
